import {Component, ViewEncapsulation} from "@angular/core";
import {SelectManySearchBaseComponent} from "../select-many-search-base.component";
import {ApiService} from "../../../../services/api/api.service";
import {AppScope} from "../../../../services/app_scope.service";
import {SelectManySearchApiComponent} from "../select-many-search-api.component";

@Component({
    selector: 'select-many-users',
    templateUrl: '../select-many-search-base.component.html',
    encapsulation: ViewEncapsulation.None,
    imports:[SelectManySearchApiComponent]
})
export class SelectManyUsersComponent extends SelectManySearchBaseComponent {

    constructor(api: ApiService,
                appScope: AppScope) {
        super(api,appScope);
        this.api_model = 'users';
        this.label = 'Select Users';
        this.classes = "'fill'";
        this.filter_by = ['name', 'alias'];
    }
}
